/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import FontAwesome from 'react-fontawesome';

import './Ranking.css';

import {
  setRank,
  listReviews,
  createReview,
} from '../../actions';

import { PercentBar } from './ReviewItem';
import ReviewItem from './ReviewItem';
import RoomInfo from './RoomInfo';
import OzModalButton from './OzModalButton';
import ReviewForm from './ReviewForm';
import WhereField from './WhereField';


class RankingExpandable extends Component {
  state = {};

  toggle() {
    this.setState({ expanded: !this.state.expanded });
    if (this.props.isRollup) {
      this.props.listReviews({ room: this.props.room.id, limit: 3 }, { local: true })
        .then(resp => {
          console.log('list reviews resp:', resp);
          if (resp.error) return;
          this.setState({ reviews: resp.items })
        });
    }
  }

  render() {
    let expanded = this.state.expanded

    let reviews = [];
    if (this.props.isRollup) {
      reviews = this.state.reviews || [];
    } else {
      reviews = [this.props.review];
    }

    let nodes = reviews.map(review => <ReviewItem noBar={!this.props.isRollup} noButton review={review} />);

    return (
      <div>
        <div className={cx('rank-full', 'collapsed', { active: !expanded })}>
          <Button bsSize="small" onClick={() => this.toggle()}>
            {this.props.isRollup && 'Show Reviews & Info'}
            {!this.props.isRollup && 'Show Review & Info'}
          </Button>
        </div>

        <div className={cx('rank-full', 'expanded', { active: expanded })}>
          <div><Button bsSize="small" onClick={() => this.toggle()}>Show Less</Button></div>
          <div className="rank-full-content">
            <div>{nodes}</div>
            <div><RoomInfo room={this.props.room} /></div>
          </div>
        </div>
      </div>
    );
  }
}


class Ranking extends Component {

  state = {
    expanded: {},
  };

  componentDidMount() {
  }

  toggleReview(review) {
    let expanded = Object.assign({}, this.state.expanded);
    expanded[review.id] = !expanded[review.id];
    this.setState({ expanded });
  }

  dragStart(e, rank, review) {
    let node = document.createElement('div');
    node.appendChild(document.createTextNode(review.room.name ));
    node.className = 'DragRoom';

    console.log('drag review', review);

    document.body.appendChild(node);
    e.dataTransfer.setDragImage(node, 0, 0);
    this.setState({ dragging: true, dragRank: rank, dragReview: review });
    this.dragNode = node;
    setTimeout(() => {
      node.style.display = 'none';
    }, 1);
  }

  dragEnd(e) {
    let rank = this.state.dragTargetRank;
    let percent = this.state.dragTargetPercent;
    let reviewId = this.state.dragReview.id;
    let params = {
      reviewId,
      rank,
      percent,
    }
    console.log('drag ended:', params);

    if (rank != this.state.dragRank) {
      this.props.setRank(params)
        .then(resp => {
          console.log('set rank resp', resp);
          if (resp.error) {
            alert('error while setting rank:', resp.error);
            return;
          }
          let profile = this.props.profile;
          return this.props.onRefresh();
        });
    }

    this.setState({
      dragging: false,
      dragRank: null,
      dragFound: null,
      dragTargetRank: null,
      dragPercent: null,
    });
    // document.remove(this.dragNode);
  }

  dragEnter(e) {
    e.preventDefault();
    let el = e.target;
    let found = false;
    let rank, percent;
    for (let el = e.target; el = el.parentNode; el && el.getAttribute) {
      rank = el.getAttribute('rank');
      percent = el.getAttribute('percent');
      if (rank) {
        found = true;
        break;
      }
    }

    this.setState({ dragFound: found, dragTargetRank: rank, dragTargetPercent: percent });
    console.log('found?', found, rank, percent);
  }

  dragLeave(e) {
    console.log('drag leave');
  }

  drop(e) {
    console.log('DROP!', e);
  }

  addReview(e, values) {
    this.props.createReview(values)
      .then(resp => {
        if (resp.error) return;
        return this.props.onRefresh()
          .then(() => this.setState({ reviewing: false }))
      });
  }

  setWhere(where) {
    let loc = {
      city: where.name,
      lat: where.lat,
      lng: where.lng,
    }
    this.setState(loc);
    this.props.onRefresh(loc);
  }

  renderFilters() {
    return (
      <div className="ranking-filters">
        <div className="ranking-filter where">
          <div className="ranking-filter-label">
            Filter by location:
          </div>
          <div className="ranking-filter-value">
            <WhereField
              onChange={(where) => {}}
              onSelect={(where) => this.setWhere(where)}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    let reviews = this.props.reviews;
    if (!reviews) return null;
    let reviewsSorted = reviews.items;
    reviewsSorted.sort((a, b) => {
      console.log('sort, compare', a, b);
      if (a.percent == b.percent) {
        console.log('comapre rank', a, b);
        return a.rank - b.rank;
      } else {
        console.log('comapre percent', a, b);
        return b.percent - a.percent;
      }
    });

    let isSelf = this.props.isSelf;
    let rank = 0;
    let nodes = reviews.items.map(review => {
      rank++;
      let myRank = rank;

      let activeDrag = myRank == this.state.dragRank;
      let dropAbove = false;
      let dropBelow = false;
      let dropInfoNode;
      let originalRank = this.state.dragRank;
      if (originalRank != myRank && myRank == this.state.dragTargetRank) {
        if (originalRank < myRank) {
          dropBelow = true;
        } else {
          dropAbove = true;
        }
        dropInfoNode = (
          <div className="drop-info">
            Make {this.state.dragReview.room.name} #{this.state.dragTargetRank} with rating {this.state.dragTargetPercent}
          </div>
        )
      }

      let expanded = !!this.state.expanded[review.id];

      return (
        <div
          draggable={isSelf}
          className={cx('review', {'is-self': isSelf, 'active-drag': activeDrag, 'drop-above': dropAbove, 'drop-below': dropBelow})}

          percent={review.percent}
          rank={myRank}
          onDrop={(e) => this.drop(e)}
          onDragStart={(e) => this.dragStart(e, myRank, review)}
          onDragEnd={(e) => this.dragEnd(e)}
          onDragEnter={(e) => this.dragEnter(e, myRank, review)}
          onDragLeave={(e) => this.dragLeave(e)}

          onClick={(e) => this.setState({ show: !this.state.show })}
          >
          {dropInfoNode}
          <div className="rank-number">
            {isSelf && <div className="grip">
             <Glyphicon glyph="th" />
             <Glyphicon glyph="th" />
             </div>}
            <div className="rank">#{rank}</div>
          </div>
          <div className="rank-info">
            <div className="rank-short">
              <div className="rank-info-inner">
                <Link to={'/r/' + review.room.slug + '/' + review.room.id}>
                <div className="name-city">
                  <span className="name">{review.room.name}</span>{' '}
                  <span className="city-wrapper">
                    {review.room.location && <span className="company">{review.room.location.company}, </span>}{' '}
                    {review.room.city && <span className="city">{review.room.city.fullName}</span>}
                  </span>
                </div>
                </Link>
                <div className="percent-controls">
                  <div className="percent">
                    <PercentBar percent={review.percent} />
                  </div>
                  <div className="controls">
                    {isSelf && <ReviewItem noBody review={review} />}
                  </div>
                </div>
              </div>
            </div>

            <RankingExpandable
              isRollup={this.props.isRollup}
              review={review}
              room={review.room}
              listReviews={this.props.listReviews}
            />

          </div>
        </div>
      );
    });

    let controlNode = null;
    if (isSelf || this.props.isRollup) {
      controlNode = (
        <OzModalButton
          modalTitle="Add Review"
          show={this.state.reviewing}
          onShow={() => this.setState({ reviewing: true })}
          onHide={() => this.setState({ reviewing: false })}
          >

          <Button bsSize="lg" bsStyle="primary">Add Review</Button>

          <ReviewForm
            modal={true}
            values={{}}
            errors={this.props.errors.review}
            onCancel={() => this.setState({ reviewing: false })}
            onSubmit={(e, values) => this.addReview(e, values)}
            buttonText="Add Review"
            cancelText="Cancel"
            >
          </ReviewForm>
        </OzModalButton>
      );
    }

    let header;
    if (this.state.city) {
      header = 'Top Escape Rooms near ' + this.state.city;
    } else {
      header = 'Top Escape Rooms Worldwide'
    }

    let head;

    if (!this.props.headless) {
      head = (
        <div>
          {!this.props.noHeader && <div className="top-header">{header}</div>}
          <div className="top-bar">
            <div className="filters">{!this.props.noFilter && this.renderFilters()}</div>
            <div className="controls">{controlNode}</div>
          </div>
        </div>
      );
    }

    return (
      <div className={cx('Ranking', {'is-rollup': this.props.isRollup})}>
        {head}
        <div className="rankings">{nodes}</div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    setRank,
    createReview,
    listReviews,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Ranking);



/** WEBPACK FOOTER **
 ** ./src/components/partials/Ranking.js
 **/